module.exports = require("lodash/isFunction");